import texts from '../texts.json';

const messages = texts;

export { messages };